import React from 'react';

const Footer = () => {
  return (
      <footer className="footer-container">
        <span className="mr-2">Copyright</span>
          <span>&copy;</span>
        <span className="mr-2">DG Business Technology, Inc., a Digital Garage company. All rights reserved</span>
      </footer>
  );
}

export default Footer;
